<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng
 * @Date: 2023-02-18 16:53:59
 * @LastEditTime: 2024-06-07 16:48:49
 * @Description: 
-->
<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <div class="title_top">相关企业介绍</div>
            <div class="title_line"></div>

            <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/Mvgx1_0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">MVGX TECH</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">MVGX TECH成立于2018年，是一家立足于亚洲，面向全球的数字化绿色金融交易所和“碳软件即服务 (CaaS)” 供应商。MVGX TECH 作为全球第一家将碳信用作为底层资产开发为金融产品并且成功发行的机构，已经建立起全球化标准的碳数字化交易架构和相关工具系统，并拥有全部非银行金融机构合规牌照。MVGX TECH致力于为政府、机构和企业等各方提供碳中和进程中各阶段的解决方案与服务。公司的碳联平台 (Carbon Connect Suite) 专注于为客户提供整合的、端到端的产品和服务，其中包括：碳足迹计算、盘查报告和核查认证，碳中和进程评级，碳信用开发和签发，和碳信用登记等。</div>
                </div>
            </div>

            <!-- <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/Acnac0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">ACNAC（亚洲碳中和评测中心）</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">ACNAC注册于香港，公司注册编号为2925468，简称“亚洲碳中和评测中心”或者”ACNAC”)，为新加坡MVGX Holdings Pte. Ltd.的全资子公司。亚洲碳中和评测中心专注于企业碳相关的评测业务，包括但不限于企业碳资产评测，碳足迹评测以及碳中和评测与评级。</div>
                </div>
            </div> -->

            <div class="box_div">
                <div class="mg_img">
                    <img src="@/assets/img/tuv0218.png" alt="">
                </div>
                <div class="right">
                    <div class="title">
                        <div class="h1">TÜV SÜD南德意志集团</div>
                        <div class="line"></div>
                    </div>
                    <div class="h2">TÜV SÜD南德提供安全并可持续发展的解决方案，是您值得信赖的合作伙伴。在过去的150多年里，我们借助各种各样的检测、认证、审核及知识服务，为合作伙伴及客户切实地增添了价值。我们一直致力于保护人类、环境和资产免受技术风险的影响，从而推动了社会和企业的进步。</div>
                </div>
            </div>

            <div class="footer">
                <div class="h3">*免责条款：</div>
                <div class="h4">1、所有数据来自企业自愿公开披露。</div>
                <div class="h4">2、排名与评分或因参评企业更新而发生变化，请关注最新公布时间。</div>
                <div class="h4">3、评价方法最终归ACNAC所有，评价解释可咨询TÜV SÜD。</div>
                <div class="h4">4、评价方：亚洲碳中和评测中心，核证方：TÜV SÜD</div>
            </div>
            <Bottoms/>
            <div class="flxed">13</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page15',
    components:{Headers, Bottoms},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.mag_t{
    margin-top: 20px;
}
.margin_t{
    margin-top: 10px;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .title_top{
            font-size: 72px;
            font-weight: bold;
            color: #013C89;
            margin: 96px 0 40px 0;
        }
        .title_line{
            width: 1252px;
            height: 2px;
            background: #013C89;
        }
        .box_div{
            width: 100%;
            margin-top: 150px;
            display: flex;
            align-items: center;
            .mg_img{
                width: 222px;
                height: 222px;
                margin-right: 48px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .right{
                width: calc(100% - 270px);
                padding-bottom: 40px;
                border-bottom: 1px solid #C5C5C6;
                .title{
                    height: 40px;
                    display: flex;
                    align-items: flex-end;
                    .h1{
                        line-height: 40px;
                        font-size: 40px;
                        font-weight: 600;
                        color: #333333;
                    }
                    .line{
                        margin-left: 10px;
                        width: 36px;
                        height: 4px;
                        background: #0DC7F5;
                    }
                }
                .h2{
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 40px;
                    text-align: justify;
                    margin-top: 40px;
                }
            }
        }
    }
}
.footer{
    width: 1252px;
    padding: 30px 0 40px 0;
    margin: 0 130px;
    position: absolute;
    bottom: 120px;
    left: 0;
    border-top: 2px solid #013C89;
    .h3{
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
    }
    .h4{
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 32px;
    }
}
</style>